import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/misc/Arrow.png'


const _hoisted_1 = { class: "navbar fixed-top navbar-expand-sm navbar-toggleable-sm navbar-light border-bottom box-shadow mb-2" }
const _hoisted_2 = { class: "d-flex flex-grow-1 align-items-center" }
const _hoisted_3 = { class: "d-none d-sm-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "align-self-center",
  src: _imports_0,
  alt: "",
  style: {"height":"20px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ml-auto" }, null, -1)
const _hoisted_6 = { class: "d-none d-md-flex" }
const _hoisted_7 = {
  class: "nav-link",
  style: {"color":"lightblue"}
}
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "/lv",
  class: "nav-link text-white"
}, "LV", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link text-white",
  style: {"padding-left":"0","padding-right":"0"}
}, "|", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "/en",
  class: "nav-link text-white"
}, "ENG", -1)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_navbar_search = _resolveComponent("navbar-search")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "navbar-brand text-white"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("navbar.title")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.pageTitle)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createVNode(_component_router_link, {
                class: "nav-link text-white",
                to: {name: _ctx.$route.name},
                style: {"padding-left":"0.25rem"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTitle), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      _createElementVNode("div", null, [
        _createVNode(_component_navbar_search)
      ]),
      (_ctx.authInfo.isAuthenticated)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.authInfo.email), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: "nav-link text-white",
                href: '/_/Account/Logout?ReturnUrl=' + _ctx.returnUrl
              }, _toDisplayString(_ctx.$t("navbar.logout")), 9, _hoisted_9)
            ])
          ], 64))
        : (_ctx.isInternal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                class: "nav-link text-white",
                href: '/_/Account/Login?ReturnUrl=' + _ctx.returnUrl
              }, _toDisplayString(_ctx.$t("navbar.login")), 9, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
      (_ctx.multiLanguage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
        : _createCommentVNode("", true)
    ])
  ]))
}